import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'gatsby-plugin-react-i18next';

const StyledButton = styled.button<{ invertedColors?: boolean }>`
  background-color: ${({ invertedColors, theme }) =>
    invertedColors ? theme.neutralPalette.white : theme.brandPalette.primary};
  border: ${({ invertedColors, theme }) =>
    invertedColors
      ? `1px solid ${theme.neutralPalette.white}`
      : `1px solid ${theme.brandPalette.primary}`};
  color: ${({ invertedColors, theme }) =>
    invertedColors ? theme.brandPalette.primary : theme.neutralPalette.white};

  padding: 12px 24px;
  border-radius: 8px;

  font-size: ${rem(16)};
  font-weight: ${(props) => props.theme.fontWeights.bold};

  transition: all 150ms ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid
      ${({ invertedColors, theme }) =>
        invertedColors
          ? theme.neutralPalette.white
          : theme.brandPalette.primary};
    color: ${({ invertedColors, theme }) =>
      invertedColors ? theme.neutralPalette.white : theme.brandPalette.primary};
    background-color: transparent;
  }
`;

interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  invertedColors?: boolean;
}

const Button = ({ children, href, invertedColors, ...props }: ButtonProps) => {
  if (href) {
    return (
      <Link to={href}>
        <StyledButton {...props} invertedColors={invertedColors}>
          {children}
        </StyledButton>
      </Link>
    );
  }

  return (
    <StyledButton {...props} invertedColors={invertedColors}>
      {children}
    </StyledButton>
  );
};

export default Button;
